import MockAuthService from "../services/MockAuthService";
import MockConsentService from "../services/MockConsentService";
import SeekrAuthService from "../services/SeekrAuthService";
import SeekrConsentService from "../services/SeekrConsentService";
import SeekrConsentServiceV2 from "../services/SeekrConsentServiceV2";
import AuthAPI from "./AuthAPI";
var authService = new SeekrAuthService();
var consentService = new SeekrConsentService();

if (process.env.REACT_APP_MOCK === "true") {
  console.log("Using Mock Services");
  authService = new MockAuthService();
  consentService = new MockConsentService();
}

var getOrCreateAuthAPISingleton = function getOrCreateAuthAPISingleton() {
  var _api;

  if (typeof window === "undefined") {
    _api = new AuthAPI(authService, consentService);
  } else if (typeof window.auth !== "undefined") {
    _api = window.auth;
  } else {
    var _window, _window$MBA__FEATURE_;

    if ((_window = window) !== null && _window !== void 0 && (_window$MBA__FEATURE_ = _window.MBA__FEATURE_FLAGS) !== null && _window$MBA__FEATURE_ !== void 0 && _window$MBA__FEATURE_["notification-preferences-v2"]) {
      console.log("Using SeekrConsentServiceV2");
      consentService = new SeekrConsentServiceV2();
    }

    _api = new AuthAPI(authService, consentService);

    _api.init();

    window.auth = _api;
  }

  return _api;
};

var api = getOrCreateAuthAPISingleton();
export { getOrCreateAuthAPISingleton };
export default api;